import React, { useContext } from 'react';
import gql from 'graphql-tag';
import { useLocation } from "react-router-dom";
import { useQuery, useMutation } from '@apollo/react-hooks';
import { NotificationContext } from '../../../components/GrowlNotifications';
import { AccountContext } from '../../../components/AccountContext';
import SurveyTemplateList from './SurveyTempList';
import { parse, filterPaginationWithSize, emptyConnection } from '../../../utils/UrlUtil';

export const LIST_QUERY = gql`
  query listSurveyTemplates(
    $accountId: ID!
    $first: Int
    $after: String
    $last: Int
    $before: String
    $filter: SurveyTemplateFilter
    $sort: SurveyTemplateSortSpecifier
  ) {
    account(id: $accountId) {
      id
      surveyTemplates(first: $first, after: $after, last: $last, before: $before, filter: $filter, sort: $sort) {
        totalCount
        indexFrom
        indexTo
        pageInfo {
          startCursor
          endCursor
          hasPreviousPage
          hasNextPage
        }
        edges {
          node {
            id
            title
            abilities
            createdOn
            updatedOn
            canDelete
          }
        }
      }
    }
  }
`;

const DELETE_TEMPLATE = gql`
  mutation deleteSurveyTemplate($input: DeleteSurveyTemplateInput!) {
    deleteSurveyTemplate(input: $input) {
      surveyTemplateId
    }
  }
`;

const SurveyTemplates = (props) => {
  const { children, variables } = props;
  const { loading, data, error } = useQuery(LIST_QUERY, {
    variables,
    fetchPolicy: 'network-only',
  });

  const [deleteTemplateMutation] = useMutation(DELETE_TEMPLATE, {
    refetchQueries: ['listSurveyTemplates'],
  });

  return children({
    surveyTemplates: { loading, data, error },
    deleteTemplate: deleteTemplateMutation,
  });
}

const SurveyTemplatesContainer = () => {
  const currentAccount = useContext(AccountContext);
  const growl = useContext(NotificationContext);
  const location = useLocation();

  const params = parse(location.search);
  const pagination = filterPaginationWithSize(params);

  const variables = {
    ...pagination,
    accountId: currentAccount,
    sort: params.sort,
    filter: params.filter,
  };
  return (
    <SurveyTemplates variables={variables}>
      {({ surveyTemplates: { loading, data, error }, deleteTemplate }) => {
        if (error) {
          growl.show({ severity: 'error', sticky: true, detail: error.message });
        }

        const connection = data && data.account ? data.account.surveyTemplates : emptyConnection();

        return (
          <SurveyTemplateList
            connection={connection}
            deleteTemplate={deleteTemplate}
            loading={loading}
          />
        );
      }}
    </SurveyTemplates>
  );
}

export default SurveyTemplatesContainer;
